import { type CrossClientQueryDecompositionOutcome, CrossClientQueryDecompositionOutcomes } from '../../../models/CrossClient'

export interface DecompositionVerdictInput {
  outcome?: CrossClientQueryDecompositionOutcome | null
  rejectionReason?: string | null
  clauseCount: number
}

const RECOGNISED_OUTCOMES: readonly string[] = Object.values(CrossClientQueryDecompositionOutcomes)

export const isRecognisedOutcome = (outcome?: string | null): outcome is CrossClientQueryDecompositionOutcome =>
  !!outcome && RECOGNISED_OUTCOMES.includes(outcome)

export const DecompositionUnusableReasons = {
  EMPTY_CRITERIA: 'empty_criteria',
  OUTCOME: 'outcome',
  LEGACY_REJECTION: 'legacy_rejection',
} as const

export type DecompositionUnusableReason = (typeof DecompositionUnusableReasons)[keyof typeof DecompositionUnusableReasons]

export const unusableReason = ({ outcome, rejectionReason, clauseCount }: DecompositionVerdictInput): DecompositionUnusableReason | null => {
  if (clauseCount === 0) {
    return DecompositionUnusableReasons.EMPTY_CRITERIA
  }
  if (isRecognisedOutcome(outcome)) {
    return outcome === CrossClientQueryDecompositionOutcomes.UNANSWERABLE ? DecompositionUnusableReasons.OUTCOME : null
  }
  return rejectionReason?.trim() ? DecompositionUnusableReasons.LEGACY_REJECTION : null
}

export const isUnusableDecomposition = (input: DecompositionVerdictInput): boolean => unusableReason(input) !== null
